module.exports = __webpack_public_path__ + "img/8exp.d3f30382.jpg";